import React from "react";
import get from "lodash/get";
import { AdContainer } from "../../ads";

import "./billboard-ad.m.css";

const BillBoardCollectionAd = ({ collection }) => {
  const adUnitId = get(collection, ["associated-metadata", "adUnitId"], "");
  const adId =
    adUnitId === "PV_Desktop_HP_Billboard_Mid01" ? "div-gpt-ad-1675836977581-0" : "div-gpt-ad-1683278304115-0 ";

  return (
    <div styleName="ad-wrapper" className="hide-mobile">
      <AdContainer AdClassName="standard-970x250" id={adId} desktop={adUnitId} />
    </div>
  );
};

export default BillBoardCollectionAd;
